import { Brand, createBranded } from '@deltasierra/type-utilities';

export type LearnSectionId = Brand<number, 'TryThisSectionId'>;
export const LearnSectionId = createBranded<LearnSectionId>();
